import { Component, OnInit, OnDestroy } from '@angular/core';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { MatDialog, MatSnackBar } from '@angular/material';
import { UserService } from 'src/app/services/user.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
})
export class ProfileComponent implements OnInit, OnDestroy {

  user;
  private userSub: Subscription;

  constructor(private userService: UserService, private dialog: MatDialog, private snackBar: MatSnackBar) { }

  ngOnInit() {
    const localUser = localStorage.getItem('user');
    this.user = JSON.parse(localUser);

    this.userSub = this.userService.getUser().subscribe(result => {
      this.user = result;
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  openDialog() {
    this.dialog.open(EditProfileComponent);
  }

  ngOnDestroy() {
    this.userSub.unsubscribe();
  }
}